module.exports = __webpack_public_path__ + "img/supervision_3000.de22bab3.webp";